import { useEffect } from 'react';

import { backbone } from '@visikon/backbone';
import { atom, useAtom, useAtomValue } from 'jotai';

export type UpdateOperation = {
  contentType: string;
  data: any;
  description: string;
};

export interface UnsavedChangesData {
  operations: UpdateOperation[];
  hasChanges: boolean;
}

const unsavedChanges = atom<UnsavedChangesData>({ operations: [], hasChanges: false });
const isEditMode = atom<boolean>(false);

export const EmbeddedMessageScript = () => {
  const [, setUnsavedChangesValue] = useAtom(unsavedChanges);
  const [, setIsEditModeValue] = useAtom(isEditMode);

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'scroll' && typeof e.data.deltaY === 'number') {
        window.requestAnimationFrame(() => window.scrollBy({ top: e.data.deltaY, behavior: 'smooth' }));
      }
      if (e.data?.type === 'unsavedChanges') {
        setUnsavedChangesValue(e.data.data);
      }
      if (e.data?.type === 'isEditMode') {
        setIsEditModeValue(e.data.data);
      }
    };
    window.parent.postMessage({ type: 'requestEditMode' }, '*');
    window.parent.postMessage({ type: 'moduleLanguage', data: backbone.store.getState().country.languageCode }, '*');

    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return null;
};

export const useSelfServiceIsEditMode = () => useAtomValue(isEditMode);

export const useSelfServiceUnsavedChanges = () => useAtomValue(unsavedChanges);
